import { render, staticRenderFns } from "./kmastra.vue?vue&type=template&id=2326644a&"
import script from "./kmastra.vue?vue&type=script&lang=js&"
export * from "./kmastra.vue?vue&type=script&lang=js&"
import style0 from "./kmastra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports